import firebase from "firebase";
//import firestore from "firebase/firestore"
var firebaseConfig = {
    apiKey: "AIzaSyAY6uN7BCWS4licC7Yeyn_i9qE6Ceji-rs",
    authDomain: "udemy-ninja-smoothies-fab0d.firebaseapp.com",
    databaseURL: "https://udemy-ninja-smoothies-fab0d.firebaseio.com",
    projectId: "udemy-ninja-smoothies-fab0d",
    storageBucket: "udemy-ninja-smoothies-fab0d.appspot.com",
    messagingSenderId: "968931780652",
    appId: "1:968931780652:web:6678a7f3690b7d6330c989",
    measurementId: "G-K0S8B25CWF"
  };
  // Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

//firebase.analytics();

//firebaseApp.firestore().settings({timestampsInSnapshots:true})

export default firebaseApp.firestore()